import { fromJS } from 'immutable';
import { useCallback } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { isTimeSeriesReport } from 'reporting-data/report/configReportGetters';
import { getCustomWidgetType } from 'reporting-data/report/reportGetters';
import { CUSTOM_WIDGET_TYPES } from 'reporting-data/tsTypes/customWidgetTypes';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
//@ts-expect-error Untyped import
import { isReportAccumulative } from 'reporting-ui-components/components/customWidgets/lib/salesAnalytics/helpers';
import { getReportWithValidRangeAndFrequency } from './common/dateRangeHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
const GOAL_VIEWS = {
  INCREMENTAL: 'INCREMENTAL',
  TOTAL: 'TOTAL'
};
const getGoalViewOptions = () => Object.values(GOAL_VIEWS).map(value => ({
  text: I18n.text(`settingLabels.quotaView.options.${value}`),
  value
}));
const SalesQuotaViewEditor = ({
  report,
  onChange
}) => {
  const selectedValue = isReportAccumulative(report) ? GOAL_VIEWS.INCREMENTAL : GOAL_VIEWS.TOTAL;
  const handleChange = useCallback(({
    target: {
      value
    }
  }) => {
    const intraperiod = value === GOAL_VIEWS.INCREMENTAL;
    const updatedReport = report.setIn(['displayParams', 'customWidget', 'options'], fromJS({
      intraperiod
    })).setIn(['config', 'intraPeriod'], intraperiod);
    const withCorrectedDate = getReportWithValidRangeAndFrequency(updatedReport);
    onChange(withCorrectedDate);
  }, [onChange, report]);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingLabels.quotaView.label"
    }),
    children: /*#__PURE__*/_jsx(Select, {
      options: getGoalViewOptions(),
      value: selectedValue,
      onChange: handleChange,
      menuWidth: "auto"
    })
  });
};
SalesQuotaViewEditor.isUsableForReport = report => isConfigReport(report) && getCustomWidgetType(report) === CUSTOM_WIDGET_TYPES.SALES_QUOTA && isTimeSeriesReport(report);
export default SalesQuotaViewEditor;